
export default {
  props: {
    item: {
      default: () => {},
    },
    product: {
      default: () => {},
    },
    newRezId: {
      default: 0,
    },
  },
  mounted() {
    this.$store.dispatch('profile.seances/SEND_TO_ADD_USERS_SEANCE', {
      api: {
        data: Number(this.newRezId),
      },
      Id: this.item.Id,
      ProcessesData: this.item.department.Processes.map((p) => p.Id).join(','),
      currency: this.item.userIp.currency,
      appointment: this.item,
      seance: this.product,
    })
  },
}
